import styled, { css } from 'styled-components'

import { ButtonWithText } from './ButtonWithText'
import StyleVariables from '../../../StyleVariables'

/**
 * OB-499: Native HTML button replaces styled(TouchableOpacity). The previous
 * RN-Web touch handler was the source of phantom-click resolution on some
 * Android OEM browsers. This element renders as a real <button>, which uses
 * the browser's native hit-testing only.
 */
export const ButtonContainer = styled.button<{
  backgroundcolor: string
  $buttonstate: boolean
  fontcolor: string
  isInline: boolean
  custompadding?: string
  custommargin?: string
  isMaxWidth?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  appearance: none;
  cursor: pointer;
  font: inherit;
  outline: none;
  padding: ${({ custompadding }) => custompadding || '8px'};
  ${({ custommargin, isInline }) =>
    custommargin
      ? css`
          margin: ${custommargin};
        `
      : css`
          margin: 15px 3px 15px 3px;
          margin-top: ${isInline ? '3px' : '15px'};
        `};
  width: ${({ isInline }) => (isInline ? 'auto' : '100%')};
  border-color: ${({ fontcolor }) => fontcolor};
  border-style: solid;
  border-width: 2px;
  max-width: ${({ isMaxWidth }) =>
    isMaxWidth ? '332px' : StyleVariables.cardMaxWidth};
  background-color: ${({ backgroundcolor, fontcolor, $buttonstate }) =>
    $buttonstate ? fontcolor : backgroundcolor};
  border-radius: 50px;
  &:disabled {
    cursor: default;
  }
`

export const DefaultButtonWithText = styled(ButtonWithText)<{
  customWidth?: string
  customMargin?: string
}>`
  border-width: 2px;
  border-radius: 30px;
  margin: ${({ customMargin }) => customMargin || '1.5rem 10px'};
  width: ${({ customWidth }) => customWidth || '320px'};
  padding: 13px 12px;
`

export const ButtonText = styled.span<{
  fontcolor: string
  $buttonstate: boolean
  activefontcolor: string
}>`
  text-align: center;
  font-size: 16px;
  font-family: ProximaNova-Regular, sans-serif;
  color: ${({ activefontcolor, $buttonstate, fontcolor }) =>
    $buttonstate ? activefontcolor : fontcolor};
`

/**
 * OB-506: Button-styled <a href>. Visual treatment mirrors ButtonContainer
 * (filled-circle CTA) so call sites that need a navigable link rather than
 * an in-page action can opt into native browser behavior (copy-link,
 * cmd-click, middle-click) while keeping the same look.
 */
export const LinkButton = styled.a<{
  backgroundcolor: string
  fontcolor: string
  custommargin?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: center;
  cursor: pointer;
  font: inherit;
  padding: 8px;
  margin: ${({ custommargin }) => custommargin || '15px 3px 15px 3px'};
  width: 100%;
  max-width: ${StyleVariables.cardMaxWidth};
  border: 2px solid ${({ fontcolor }) => fontcolor};
  border-radius: 50px;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  color: ${({ fontcolor }) => fontcolor};
  text-decoration: none;
  text-align: center;
  font-family: ProximaNova-Regular, sans-serif;
  font-size: 16px;
  &:hover {
    background-color: ${({ fontcolor }) => fontcolor};
    color: ${({ backgroundcolor }) => backgroundcolor};
  }
`
